import {
  BareMetalCloud,
  CloudChangelog,
  Email,
  Globe,
  Helpe,
  HostedPrivateCloud,
  HostingChangelog,
  Leaf,
  LiveChat,
  LockClose,
  Monitor,
  Network,
  NetworkStatus,
  Networkv2,
  OVHLogo,
  OVHShortLogo,
  Observability,
  Phone,
  PublicCloud,
  SecurityIdentityOperation,
  ServerV2,
  ShieldCheck,
  ShoppingCartPlus,
  Sparkle,
  Star,
  Store,
  Sunrise,
  Telecom,
  Webcloud,
} from '../assets-icon-svg/icons';

const containerIcons = {
  BareMetalCloud,
  HostedPrivateCloud,
  Network,
  PublicCloud,
  SecurityIdentityOperation,
  Sunrise,
  Telecom,
  Webcloud,
  Helpe,
  Leaf,
  LiveChat,
  NetworkStatus,
  Store,
  Email,
  Globe,
  LockClose,
  Monitor,
  Networkv2,
  Phone,
  ServerV2,
  ShieldCheck,
  ShoppingCartPlus,
  Sparkle,
  Star,
  CloudChangelog,
  HostingChangelog,
  OVHLogo,
  OVHShortLogo,
  Observability,
};

export default containerIcons;
